import React, { useMemo } from 'react'
import './EmptyMessage.css'

interface EmptyMessageProps {
  message?: string
}

const DefaultMessage = 'NO RESULTS FOUND'

export const EmptyMessage = (props: EmptyMessageProps) => {
  const { message } = props

  const _message = useMemo(() => {
    if (message) return message
    return DefaultMessage
  }, [message])

  return <div className="empty-container">{_message}</div>
}
